import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { AppraiseeProcessDetail } from '../models/process-models';
import { parseUtcDate, getShortDateString } from '../helpers/date-helper';


@Injectable()
export class AppraiseeService {
    private readonly apiController = 'api/appraisee';

    constructor(private readonly httpClient: HttpClient) {
    }

    updateInfo(appraiseeProcessDetail: AppraiseeProcessDetail) {
        return this.httpClient.put(`${this.apiController}/updateInfo`, appraiseeProcessDetail).pipe(distinctUntilChanged()) as Observable<any>;
    }

    changeDeadline(date: Date, appraiseeIds: Array<number>): Observable<any> {
        let dateString = getShortDateString(parseUtcDate(date));
        return this.httpClient.put(`${this.apiController}/changeDeadline/${dateString}`, appraiseeIds).pipe(distinctUntilChanged()) as Observable<any>;
    }
}